import styled from "styled-components"

export const Card = styled.div`
  background-color: ${({theme}) => theme.colors.utility.highlight};
  border-radius: ${({theme}) => theme.border.radius.large};
  padding-left: ${({theme}) => theme.spacing.two};
`
interface LabelProps {
  isEnabled?: boolean,
  color?: string
}

export const Label = styled.div<LabelProps>`
  font-size: 10px;
  height: 21px;
  line-height: 21px;
  color: ${({theme}) => theme.colors.greys.white};
  background-color: ${({theme, isEnabled, color}) => isEnabled ? (color || theme.colors.tertiary.g_400) : theme.colors.primary2_100};
  border-radius: 5px;
  padding-left: ${({theme}) => theme.spacing.one};
  padding-right: ${({theme}) => theme.spacing.one};
`
